module.exports = __webpack_public_path__ + "img/20210906-1630913617846692.b456c37c.png";